// Home page Slider
var mySwiper = new Swiper('.hero_swiper_slider', {
    loop: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      dynamicBullets: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    speed: 600,
    effect: 'fade',
    fadeEffect: {
          crossFade: true,
     },
  });

  
  var smoothSwiper = new Swiper('.supplies_sch_collection_even', {
    speed: 6000,
    autoplay: {
      delay: 0,
    },
    loop: true,
    slidesPerView: 4.5,
    freeMode: false,
    allowTouchMove: false,
  });

  
var smoothSwiper = new Swiper('.supplies_sch_collection_odd', {
  speed: 6000,
  autoplay: {
    delay: 0,
  },
  loop: true,
  slidesPerView: 4.5,
  freeMode: false,
  allowTouchMove: false,
});